import { Component, forwardRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'pnx-radio',
    templateUrl: 'radiobutton.control.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RadioControl), multi: true }
    ]
})
export class RadioControl implements ControlValueAccessor {

    @Input() label: string = '';
    @Input() labelstyle: string = 'control-label';
    @Input() radiocontainerstyle: string = 'col-md-9';
    @Input() radioboxstyle: string = '';
    @Input() disable: boolean = false;
    @Input('value') _value: any;
    @Input() dataList = Array<RadioGroupList>();
    @Input() defaultValue: boolean = false;
    @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

    ngOnChanges(Changes: SimpleChanges) {
        
    }

    propagateChange: any = () => { };

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    onValueChange(event) {
        this.value = event.value;
        this.onChange.emit(this.value);
    }

    writeValue(value): void {
        if (!value && this.defaultValue && this.dataList.length > 0)
            this.value = this.dataList[0].value;
        else
            this.value = value;
    }

    registerOnChange(fn): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn): void {
        
    }

    setDisabledState(isDisabled: boolean): void {
       
    }
}

class RadioGroupList {
    constructor() { }
    public value: string;
    public viewValue: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/controls/radiobutton.control.ts